// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServiceRegionRouteImport } from './routes/$serviceRegion'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AdminRabattcodesRouteImport } from './routes/admin-rabattcodes'
import { Route as AdminRechnungenRouteImport } from './routes/admin-rechnungen'
import { Route as AgbRouteImport } from './routes/agb'
import { Route as AnbieterPreiseRouteImport } from './routes/anbieter-preise'
import { Route as ArtikelRouteImport } from './routes/artikel'
import { Route as AuftraegeRouteImport } from './routes/auftraege'
import { Route as AuftragBestaetigenRouteImport } from './routes/auftrag-bestaetigen'
import { Route as AuftragEinstellenRouteImport } from './routes/auftrag-einstellen'
import { Route as AuftragVerwaltenRouteImport } from './routes/auftrag-verwalten'
import { Route as AuftragnehmerRouteImport } from './routes/auftragnehmer'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as ImmobilienRouteImport } from './routes/immobilien'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as KontoRouteImport } from './routes/konto'
import { Route as LeistungenRouteImport } from './routes/leistungen'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MaklerRouteImport } from './routes/makler'
import { Route as MehrfamilienhausVerkaufenRouteImport } from './routes/mehrfamilienhaus-verkaufen'
import { Route as PreiseRouteImport } from './routes/preise'
import { Route as RegistrierenRouteImport } from './routes/registrieren'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as ApiBillingEmailCronRouteImport } from './routes/api.billing-email-cron'
import { Route as ApiJobNotificationCronRouteImport } from './routes/api.job-notification-cron'
import { Route as ArtikelSlugRouteImport } from './routes/artikel.$slug'
import { Route as AuftraegeSlugRouteImport } from './routes/auftraege.$slug'
import { Route as GewerkeGewerkRouteImport } from './routes/gewerke.$gewerk'
import { Route as HandwerkerStadtRouteImport } from './routes/handwerker.$stadt'
import { Route as HandwerkerverzeichnisRegionRouteImport } from './routes/handwerkerverzeichnis.$region'
import { Route as ImmobilieVerkaufenStadtRouteImport } from './routes/immobilie-verkaufen.$stadt'
import { Route as MaklerRegionRouteImport } from './routes/makler_.$region'
import { Route as RechnungTokenRouteImport } from './routes/rechnung.$token'
import { Route as HandwerkerStadtGewerkRouteImport } from './routes/handwerker.$stadt_.$gewerk'
import { Route as HandwerkerverzeichnisGewerkGewerkRouteImport } from './routes/handwerkerverzeichnis.gewerk.$gewerk'
import { Route as MaklerLeistungenLeistungRouteImport } from './routes/makler_.leistungen.$leistung'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServiceRegionRoute = ServiceRegionRouteImport.update({
            id: '/$serviceRegion',path: '/$serviceRegion',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AdminRabattcodesRoute = AdminRabattcodesRouteImport.update({
            id: '/admin-rabattcodes',path: '/admin-rabattcodes',getParentRoute: () => rootRouteImport
          })
const AdminRechnungenRoute = AdminRechnungenRouteImport.update({
            id: '/admin-rechnungen',path: '/admin-rechnungen',getParentRoute: () => rootRouteImport
          })
const AgbRoute = AgbRouteImport.update({
            id: '/agb',path: '/agb',getParentRoute: () => rootRouteImport
          })
const AnbieterPreiseRoute = AnbieterPreiseRouteImport.update({
            id: '/anbieter-preise',path: '/anbieter-preise',getParentRoute: () => rootRouteImport
          })
const ArtikelRoute = ArtikelRouteImport.update({
            id: '/artikel',path: '/artikel',getParentRoute: () => rootRouteImport
          })
const AuftraegeRoute = AuftraegeRouteImport.update({
            id: '/auftraege',path: '/auftraege',getParentRoute: () => rootRouteImport
          })
const AuftragBestaetigenRoute = AuftragBestaetigenRouteImport.update({
            id: '/auftrag-bestaetigen',path: '/auftrag-bestaetigen',getParentRoute: () => rootRouteImport
          })
const AuftragEinstellenRoute = AuftragEinstellenRouteImport.update({
            id: '/auftrag-einstellen',path: '/auftrag-einstellen',getParentRoute: () => rootRouteImport
          })
const AuftragVerwaltenRoute = AuftragVerwaltenRouteImport.update({
            id: '/auftrag-verwalten',path: '/auftrag-verwalten',getParentRoute: () => rootRouteImport
          })
const AuftragnehmerRoute = AuftragnehmerRouteImport.update({
            id: '/auftragnehmer',path: '/auftragnehmer',getParentRoute: () => rootRouteImport
          })
const DatenschutzRoute = DatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => rootRouteImport
          })
const ImmobilienRoute = ImmobilienRouteImport.update({
            id: '/immobilien',path: '/immobilien',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const KontoRoute = KontoRouteImport.update({
            id: '/konto',path: '/konto',getParentRoute: () => rootRouteImport
          })
const LeistungenRoute = LeistungenRouteImport.update({
            id: '/leistungen',path: '/leistungen',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MaklerRoute = MaklerRouteImport.update({
            id: '/makler',path: '/makler',getParentRoute: () => rootRouteImport
          })
const MehrfamilienhausVerkaufenRoute = MehrfamilienhausVerkaufenRouteImport.update({
            id: '/mehrfamilienhaus-verkaufen',path: '/mehrfamilienhaus-verkaufen',getParentRoute: () => rootRouteImport
          })
const PreiseRoute = PreiseRouteImport.update({
            id: '/preise',path: '/preise',getParentRoute: () => rootRouteImport
          })
const RegistrierenRoute = RegistrierenRouteImport.update({
            id: '/registrieren',path: '/registrieren',getParentRoute: () => rootRouteImport
          })
const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
            id: '/sitemap.xml',path: '/sitemap.xml',getParentRoute: () => rootRouteImport
          })
const ApiBillingEmailCronRoute = ApiBillingEmailCronRouteImport.update({
            id: '/api/billing-email-cron',path: '/api/billing-email-cron',getParentRoute: () => rootRouteImport
          })
const ApiJobNotificationCronRoute = ApiJobNotificationCronRouteImport.update({
            id: '/api/job-notification-cron',path: '/api/job-notification-cron',getParentRoute: () => rootRouteImport
          })
const ArtikelSlugRoute = ArtikelSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ArtikelRoute
          })
const AuftraegeSlugRoute = AuftraegeSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => AuftraegeRoute
          })
const GewerkeGewerkRoute = GewerkeGewerkRouteImport.update({
            id: '/gewerke/$gewerk',path: '/gewerke/$gewerk',getParentRoute: () => rootRouteImport
          })
const HandwerkerStadtRoute = HandwerkerStadtRouteImport.update({
            id: '/handwerker/$stadt',path: '/handwerker/$stadt',getParentRoute: () => rootRouteImport
          })
const HandwerkerverzeichnisRegionRoute = HandwerkerverzeichnisRegionRouteImport.update({
            id: '/handwerkerverzeichnis/$region',path: '/handwerkerverzeichnis/$region',getParentRoute: () => rootRouteImport
          })
const ImmobilieVerkaufenStadtRoute = ImmobilieVerkaufenStadtRouteImport.update({
            id: '/immobilie-verkaufen/$stadt',path: '/immobilie-verkaufen/$stadt',getParentRoute: () => rootRouteImport
          })
const MaklerRegionRoute = MaklerRegionRouteImport.update({
            id: '/makler_/$region',path: '/makler/$region',getParentRoute: () => rootRouteImport
          })
const RechnungTokenRoute = RechnungTokenRouteImport.update({
            id: '/rechnung/$token',path: '/rechnung/$token',getParentRoute: () => rootRouteImport
          })
const HandwerkerStadtGewerkRoute = HandwerkerStadtGewerkRouteImport.update({
            id: '/handwerker/$stadt_/$gewerk',path: '/handwerker/$stadt/$gewerk',getParentRoute: () => rootRouteImport
          })
const HandwerkerverzeichnisGewerkGewerkRoute = HandwerkerverzeichnisGewerkGewerkRouteImport.update({
            id: '/handwerkerverzeichnis/gewerk/$gewerk',path: '/handwerkerverzeichnis/gewerk/$gewerk',getParentRoute: () => rootRouteImport
          })
const MaklerLeistungenLeistungRoute = MaklerLeistungenLeistungRouteImport.update({
            id: '/makler_/leistungen/$leistung',path: '/makler/leistungen/$leistung',getParentRoute: () => rootRouteImport
          })





const ArtikelRouteChildren = {
  ArtikelSlugRoute: ArtikelSlugRoute
}

const ArtikelRouteWithChildren = ArtikelRoute._addFileChildren(ArtikelRouteChildren)




const AuftraegeRouteChildren = {
  AuftraegeSlugRoute: AuftraegeSlugRoute
}

const AuftraegeRouteWithChildren = AuftraegeRoute._addFileChildren(AuftraegeRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,ServiceRegionRoute: ServiceRegionRoute,AdminRoute: AdminRoute,AdminRabattcodesRoute: AdminRabattcodesRoute,AdminRechnungenRoute: AdminRechnungenRoute,AgbRoute: AgbRoute,AnbieterPreiseRoute: AnbieterPreiseRoute,ArtikelRoute: ArtikelRouteWithChildren,AuftraegeRoute: AuftraegeRouteWithChildren,AuftragBestaetigenRoute: AuftragBestaetigenRoute,AuftragEinstellenRoute: AuftragEinstellenRoute,AuftragVerwaltenRoute: AuftragVerwaltenRoute,AuftragnehmerRoute: AuftragnehmerRoute,DatenschutzRoute: DatenschutzRoute,ImmobilienRoute: ImmobilienRoute,ImpressumRoute: ImpressumRoute,KontoRoute: KontoRoute,LeistungenRoute: LeistungenRoute,LoginRoute: LoginRoute,MaklerRoute: MaklerRoute,MehrfamilienhausVerkaufenRoute: MehrfamilienhausVerkaufenRoute,PreiseRoute: PreiseRoute,RegistrierenRoute: RegistrierenRoute,SitemapDotxmlRoute: SitemapDotxmlRoute,ApiBillingEmailCronRoute: ApiBillingEmailCronRoute,ApiJobNotificationCronRoute: ApiJobNotificationCronRoute,GewerkeGewerkRoute: GewerkeGewerkRoute,HandwerkerStadtRoute: HandwerkerStadtRoute,HandwerkerverzeichnisRegionRoute: HandwerkerverzeichnisRegionRoute,ImmobilieVerkaufenStadtRoute: ImmobilieVerkaufenStadtRoute,MaklerRegionRoute: MaklerRegionRoute,RechnungTokenRoute: RechnungTokenRoute,HandwerkerStadtGewerkRoute: HandwerkerStadtGewerkRoute,HandwerkerverzeichnisGewerkGewerkRoute: HandwerkerverzeichnisGewerkGewerkRoute,MaklerLeistungenLeistungRoute: MaklerLeistungenLeistungRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)